import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Swal from "sweetalert2";
import BaseUrl from "../Components/BaseUrl";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
  });
  const [error, setError] = useState({
    email: "",
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setError({ ...error, [id]: "" });
  };
  const validateForm = () => {
    let result = true;
    let errors = {};
    if (formData.email.trim() === "") {
      errors.email = "please enter an email address";
      result = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid!";
      result = false;
    }

    setError(errors);
    return result;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = validateForm();
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + "forgot-password",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Reset Link Sent!",
            html: "A password reset link has been sent to your email.<br><br><strong>Note:</strong> If you don’t see it, check your spam folder.",
            confirmButtonText: "Okay",
            showConfirmButton: true,
          });

          // navigate("/user/home");
        } else {
          Swal.fire({
            icon: "error",
            title: "Invalid Email!",
            text: "If this email is registered, you will receive a password reset link shortly.",
            confirmButtonText: "Okay",
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <>
      <div className="flex items-center justify-center min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
          <h2 className="text-3xl font-bold mb-6 text-center">
            Forgot Password
          </h2>
          <form>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="email"
              >
                Email <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                value={formData.email}
                onChange={handleChange}
                type="text"
                placeholder="Email or phone"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.email}
              </span>
            </div>
            <div>
              <p className="text-sm text-gray-600">
                We'll send a verification code to this email or phone number if
                it matches an existing LinkedIn account.
              </p>
            </div>

            <div className="mb-6  mt-8 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg py-2 px-4 h-12 rounded-full w-56"
                type="button"
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>

            <div className="text-center">
              <Link to="/user/login" className="text-gray-600">
                Return
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
